import styles from "./Finish.module.scss";
import { BsCalendar4 } from "react-icons/bs";
import { VscCheck } from "react-icons/vsc";
import moment from "moment";
import Utilities from "../utils/Utilities";

import "add-to-calendar-button";

function Finish(props) {
  const weekday = [
    "Domenica",
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
  ];
  const monthNames = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ];
  let objectDate = props.selectedDay;

  let weekDay = weekday[objectDate.getDay()];

  let day = objectDate.getDate();

  let month = monthNames[objectDate.getMonth()];

  let year = objectDate.getFullYear();

  const endTime = Utilities.getEndTime(
    props.selectedServives,
    props.selectedTime
  );

  const startDate =
    props.selectedDay.getFullYear() +
    "-" +
    (props.selectedDay.getMonth() + 1 < 10 ? "0" : "") +
    (props.selectedDay.getMonth() + 1) +
    "-" +
    (moment(props.selectedDay).get("date") < 10 ? "0" : "") +
    moment(props.selectedDay).get("date");

  return (
    <div className={styles["finish-container"]}>
      <div
        className={styles["finish-title"]}
        style={{
          backgroundColor: props.error
            ? "var(--primaryError)"
            : "var(--primaryColor)",
        }}
      >
        {props.error ? "Pagamento non riuscito" : "Prenotazione conclusa"}
      </div>
      <div className={styles["finish-body"]}>
        <span className={styles["content-body"]}>
          {!props.error ? (
            <>
              <BsCalendar4
                size="53"
                className={styles["color-primary-color"]}
              />
              <VscCheck
                size="30"
                className={styles["color-primary-color"]}
                style={{ marginBottom: "32px", marginLeft: "5px" }}
              />
            </>
          ) : (
            <img src="/error-excalimation.svg" alt="img" />
          )}
        </span>
        {!props.error && (
          <span className={styles["content-title"]}>Congratulazioni!</span>
        )}
        <span className={styles["content-body"]}>
          {!props.error
            ? "Hai completato la tua prenotazione con successo!"
            : "Purtroppo il tuo pagamento non è andato a buon fine e quindi non abbiamo ancora confermato la tua prenotazione "}
        </span>
        <span className={styles["content-remind-2"]}>
          {!props.error
            ? `Ricordati che il giorno dell'appuntamento è`
            : "Puoi sempre pagare direttamente in loco!"}
        </span>
        {!props.error && (
          <div className={styles["content-remind-details"]}>
            {weekDay} {day} {month} {year}
            <br />
            ALLE ORE {props.selectedTime.time}
          </div>
        )}
        {!props.error && (
          <span className={styles["content-remind"]}>
            AGGIUNGI AL TUO CALENDARIO
            <br />
            <div className={styles["add-to-calendar-container"]}>
              <add-to-calendar-button
                name="Appuntamento"
                description="Appuntamento"
                startDate={startDate}
                startTime={props.selectedTime.time}
                endTime={endTime}
                timeZone="Europe/Rome"
                location="World Wide Web"
                options="'Google', 'Apple'"
                listStyle="dropdown-static"
                buttonStyle="round"
                hideTextLabelButton
                buttonsList
                hideBackground
                hideCheckmark
                label="AGGIUNGI AL TUO CALENDARIO"
                lightMode="system"
              ></add-to-calendar-button>
            </div>
          </span>
        )}
        {/* {props.error && <span className={styles["error"]}>{props.error}</span>} */}
        {!props.error ? (
          <button
            onClick={() => {
              window.parent?.postMessage("back", "*");
            }}
            className={styles["go-to-home-button"]}
            style={{ cursor: "pointer" }}
          >
            {props.payOnline ? "TORNA INDIETRO" : "Torna indietro"}
          </button>
        ) : (
          <>
            <button
              onClick={() => {
                props.setFinishedWithError(false);
                props.setFinished(true);
                props.seCurrenttStep(3);
                props.setErrorInStripe(false);
              }}
              className={styles["go-to-home-button"]}
              style={{ cursor: "pointer" }}
            >
              CONFERMA e paga in sede!
            </button>
            <button
              onClick={() => {
                window.location.reload();
              }}
              className={styles["go-to-home-button-white"]}
              style={{ cursor: "pointer" }}
            >
              torna indietro
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Finish;
